import { auth } from "../api/firebase";
import { useEffect, useState } from "react";

export default () => {
  const [isAuthenticated, setAuthentication] = useState(false);
  const [isLoading, setLoadingAuth] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const idToken = await user.getIdTokenResult();
        if (idToken) {
          if(idToken.claims.admin === true){
            setAuthentication(true);
          }
          else{
            setAuthentication(false);
          }      
        }
        else {
          setAuthentication(false);
        }
      }
      else {
        setAuthentication(false);
      }
      setLoadingAuth(false)
    });
    return () => {
      unsubscribe();
    };
  }, [isAuthenticated]);

  return [isAuthenticated, isLoading];
};
